import { Vue } from "./hook";
import App from "./App.vue";
import Element from "element-ui";
import router from "./router";
import actions from "./store/action";
import "./style/reset.css";
import store from "./store/index";
import { registerMicroApps, start } from "qiankun";
import './config'

const isDevelopment = process.env.VUE_APP_ENV === "development";
const base = process.env.VUE_APP_BASE_API || "";

Vue.config.productionTip = false;
registerMicroApps(
  [
    {
      //商品管理
      name: "goods",
      entry: isDevelopment ? "//localhost:6060" : base + "/child/goods/",
      container: "#appsBox",
      activeRule: base + "/child-goods",
      props: {
        actions,
      },
    },
    {
      //权限系统
      name: "permission",
      entry: isDevelopment ? "//localhost:9095" : base + "/child/permission/",
      container: "#appsBox",
      activeRule: base + "/child-permission",
      props: {
        actions,
      },
    },
    {
      //企业管理
      name: "enterprise",
      entry: isDevelopment ? "//localhost:1065" : base + "/child/enterprise/",
      container: "#appsBox",
      activeRule: base + "/child-enterprise",
      props: {
        actions,
      },
    },
    {
      //支付结算
      name: "payment",
      entry: isDevelopment ? "//localhost:3025" : base + "/child/payment/",
      container: "#appsBox",
      activeRule: base + "/child-payment",
      props: {
        actions,
      },
    },
    {
      //调度平台
      name: "dispatch",
      entry: isDevelopment ? "//localhost:7777" : base + "/child/dispatch/",
      container: "#appsBox",
      activeRule: base + "/child-dispatch",
    }, // 签约系统
    {
      name: "signing",
      entry: isDevelopment ? `//localhost:8881` : base + "/child/signing/",
      container: "#appsBox",
      activeRule: base + "/child-signing",
      props: {
        actions,
      },
    },
    {
      //焦虑问卷
      name: "question",
      entry: isDevelopment ? "//localhost:5000" : base + "/child/question/",
      container: "#appsBox",
      activeRule: base + "/child-question",
      props: {
        actions,
      },
    },
    {
      //销售工具
      name: "sale",
      entry: isDevelopment ? "//localhost:2000" : base + "/child/sale/",
      container: "#appsBox",
      activeRule: base + "/child-sale",
    },
    {
      //价值传递
      name: "valueTransfer",
      entry: isDevelopment
        ? "//localhost:7778"
        : base + "/child/valueTransfer/",
      container: "#appsBox",
      activeRule: base + "/child-valueTransfer",
      props: {
        actions,
      },
    },
    {
      //管家系统
      name: "steward",
      entry: isDevelopment ? "//localhost:8202" : base + "/child/steward/",
      container: "#appsBox",
      activeRule: base + "/child-steward",
      props: {
        actions,
      },
    },
    {
      //订单中心
      name: "order",
      entry: isDevelopment ? "//localhost:8203" : base + "/child/order/",
      container: "#appsBox",
      activeRule: base + "/child-order",
      props: {
        actions,
      },
    },
    {
      //内容中心
      name: "contentCenter",
      entry: isDevelopment
        ? "//localhost:7779"
        : base + "/child/contentCenter/",
      container: "#appsBox",
      activeRule: base + "/child-contentCenter",
    },
    {
      //消息管理中心
      name: "messageCenter",
      entry: isDevelopment
        ? "//localhost:1888"
        : base + "/child/messageCenter/",
      container: "#appsBox",
      activeRule: base + "/child-messageCenter",
    },
  ],
  {
    afterMount: (app) => {
      setTimeout(() => {
        store.dispatch("app/setLoading", false);
      }, 500);
    },
  }
);

start({ prefetch: false });
Vue.use(Element);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
